module.exports = __webpack_public_path__ + "static/media/banderitasMobile.9e3e8d7a.svg";